module.exports = __webpack_public_path__ + "static/media/mall.17d6c7d2.svg";